module.exports = __webpack_public_path__ + "img/61_9.7b1a1b12.png";